<template>
  <b-dropdown
    class="module-navigator-picker border"
    :class="{
      dark: isDarkMode
    }"
    :variant="isDarkMode ? 'dark' : 'light'"
    block
  >
    <template #button-content>
      <div class="module-navigator-picker--content px-1">
        {{ currentModuleLabel }}
      </div>
    </template>
    <b-dropdown-item
      v-if="showModule('core:communicatorEnabled')"
      to="/conversations"
      :active="communicatorRoutes.includes($route.name)"
    >
      ConveyCommunicator
    </b-dropdown-item>
    <b-dropdown-item
      v-if="showModule('core:alertEnabled')"
      :to="currentCampaignHomeRoute"
      :active="alertRoutes.includes($route.name)"
    >
      ConveyAlert
    </b-dropdown-item>
    <b-dropdown-item
      v-if="showModule('core:connectEnabled')"
      to="/connect"
      :active="connectRoutes.includes($route.name)"
    >
      ConveyConnect
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters } from "vuex";

export default {
  name: "ModuleNavigatorPicker",
  props: {
    isDarkMode: Boolean,
  },
  data() {
    return {
      communicatorRoutes: [
        "Conversations Dashboard",
        "Conversation Detail",
      ],
      alertRoutes: [
        "Campaigns",
        "Campaign Dashboard",
        "Campaign Events",
        "Campaign Event Detail",
        "Campaign Subscribers",
        "Campaign Subscriber Detail",
      ],
      connectRoutes: [
        "Convey Connect Dashboard",
        "Convey Connect Calls",
        "Convey Connect Settings",
      ],
    };
  },
  computed: {
    ...mapState({
      currentAgency: (state) => state.agency.agency,
    }),
    ...mapGetters("campaigns", ["currentCampaign"]),
    currentCampaignHomeRoute() {
      if (this.currentCampaign) {
        return `/campaigns/${this.currentCampaign.campaign_id}`;
      }
      return "/campaigns";
    },
    currentModuleLabel() {
      if (this.communicatorRoutes.includes(this.$route.name)) {
        return "ConveyCommunicator";
      } else if (this.alertRoutes.includes(this.$route.name)) {
        return "ConveyAlert";
      } else if (this.connectRoutes.includes(this.$route.name)) {
        return "ConveyConnect";
      }
      return "";
    }
  },
  methods: {
    showModule(moduleName) {
      return this.currentAgency
        ? this.currentAgency.settings[moduleName] === true || this.currentAgency.settings[moduleName] === "true"
        : false;
    },
  },
};
</script>

<style lang="scss">
.module-navigator-picker {
  border-color: #455a64 !important;
  border-radius: 1.5rem;
  
  >button {
    display: flex;
    align-items: center;
  }

  .dropdown-menu {
    min-width: 300px;
    max-width: 80vw;
    max-height: 240px;
    overflow-y: auto;

    .dropdown-item {
      white-space: wrap;
    }
  }

  &--content {
    width: 100%;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>